import { render, staticRenderFns } from "./content-list.vue?vue&type=template&id=e2905118&scoped=true&"
import script from "./content-list.vue?vue&type=script&lang=js&"
export * from "./content-list.vue?vue&type=script&lang=js&"
import style0 from "./content-list.vue?vue&type=style&index=0&id=e2905118&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2905118",
  null
  
)

export default component.exports